
const NAMESPACE = 'SYSTEM';

export const ActionTypes = {
  SetPersistentQueryParams: `${NAMESPACE}/SET_PERSISTENT_QUERY_PARAMS`
};

export const setPersistentQueryParams = data => dispatch =>
  dispatch({ type: ActionTypes.SetPersistentQueryParams, data });
